import { Component, OnInit } from '@angular/core';
import { Location } from './location.model';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { WsService } from '../../../services/websocket/WsService';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { CaptivePortal } from '../captive-portal/cp-add-update/cp.model';
import { TreeNode } from 'primeng/primeng';
import { Globals } from '../../../globals/Globals';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-location-setup',
  templateUrl: './location-setup.component.html',
  styleUrls: ['./location-setup.component.css'],
})
export class LocationSetupComponent extends SuperClass implements OnInit {
  zoom = 15;

  venues: Location[];
  totalVenues;
  timeZones;

  selectedRow: Location;
  newVenue: Location;

  newVenueForm: FormGroup;
  selectedRowForm: FormGroup;

  countries;
  filteredTimeZones;
  selectedLocation;

  display = false;
  displayCSV = false;
  massCreation = false;
  addToGroup = false;
  venueGroup;
  venueGroups;
  venueGroupsTree: TreeNode[];
  cloneCp = false;
  cp: CaptivePortal;
  cpList: CaptivePortal[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Location Setup',
        routerLink: [{ outlets: { sub: [RouterConst.LOCATION_SETUP] } }],
      },
    ]);
    this.newVenue = new Location();
  }

  reloadData() {
    this.http_getAllLocations((data: any) => {
      this.venues = data.payload;
      this.totalVenues = data.payload.length;
    });

    this.http_getAllCountriesList((data: any) => {
      this.countries = data.payload;
    });

    this.http_getTimeZones((data: any) => {
      this.timeZones = data.payload;
    });
    this.http_getAllCp((data: any) => {
      this.cpList = data.payload;
    });
    this.http_getTreeInfo(
      {
        withLocations: false,
        getAll: true,
        withNoParent: false,
        excludeId: undefined,
      },
      (data: any) => {
        if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
          this.venueGroupsTree = JSON.parse(data.payload);
        }
      },
    );
    this.http_getVenueGroups((data: any) => {
      this.venueGroups = data.payload;
    });

    this.selectedRowForm = this.fb.group({
      time_zone: new FormControl('', Validators.required),
      loc_code: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      lat: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^-?[0-9]+(.[0-9]+$)'),
          Validators.required,
        ]),
      ),
      long: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^-?[0-9]+(.[0-9]+$)'),
          Validators.required,
        ]),
      ),
    });

    this.newVenueForm = this.fb.group({
      time_zone: new FormControl('', Validators.required),
      loc_code: new FormControl('', Validators.required),
      name: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      lat: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^-?[0-9]+(.[0-9]+$)'),
          Validators.required,
        ]),
      ),
      long: new FormControl(
        '',
        Validators.compose([
          Validators.pattern('^-?[0-9]+(.[0-9]+$)'),
          Validators.required,
        ]),
      ),
    });
  }

  selectRow(e) {
    this.selectedRow = new Location(e.data);
  }

  addNewVenuesFromFile() {
    this.displayCSV = true;
  }

  choseCSV() {
    if (!this.venueGroup) {
      this.showErrorMessage('Venue Group must be selected');
      return;
    }
    if (!this.cp) {
      this.showErrorMessage('Captive Portal must be selected');
      return;
    }
    document.getElementById('venuesFileId').click();
  }

  venuesFileUploaded(file: File) {
    const formData: FormData = new FormData();
    formData.append('csvFile', file);
    formData.append('groupId', this.venueGroup.id);
    formData.append('cpId', this.cp.id);
    this.http_createVenuesFromCSV(formData, data => {
      this.displayCSV = false;
      this.venues = data.payload;
    });
  }

  addNewVenue() {
    this.unselectRow();
    this.display = true;
  }

  createNewVenue() {
    const groupId = this.venueGroup ? this.venueGroup.id : undefined;
    const cpId = this.cp ? this.cp.id : undefined;

    // const requiredFields = [
    //   {id: 'new_time_zone', value: this.newVenue.timeZone, fieldName: 'Time Zone'},
    //   {id: 'new_loc_code', value: this.newVenue.venueCode, fieldName: 'Loc Code'},
    //   {id: 'new_name', value: this.newVenue.name, fieldName: 'Name'},
    //   {id: 'new_address', value: this.newVenue.address1, fieldName: 'Address'},
    //   {id: 'new_country', value: this.newVenue.country, fieldName: 'Country'},
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }

    // const conditions = [
    //   {
    //     condition: (this.timeZones.indexOf(this.newVenue.timeZone) < 0),
    //     id: 'time_zone', message: 'Time Zone must be selected from list'
    //   },
    //   {
    //     condition: (this.addToGroup && isNullOrUndefined(groupId)),
    //     id: 'time_zone', message: 'Venue Group can\'t be empty'
    //   },
    //   {
    //     condition: (this.cloneCp && isNullOrUndefined(cpId)),
    //     id: 'time_zone', message: 'Captive Portal can\'t be empty'
    //   }
    // ];
    // if (this.hasErrorConditions(conditions)) {
    //   return;
    // }

    const reqBody = {
      venues: this.newVenue,
      addToGroup: this.addToGroup,
      groupId: groupId,
      cloneCp: this.cloneCp,
      cpId: cpId,
    };

    this.http_createNewVenue(reqBody, (data: any) => {
      this.showSuccessMessage('New Location has been created');
      this.unselectRow();
      this.venues = data.payload;

      if (!this.massCreation) {
        this.display = false;
      }
      this.newVenue.venueCode = '';
      this.newVenue.name = '';
    });
  }

  deleteVenue() {
    this.http_deleteVenue({ id: this.selectedRow.id }, (data: any) => {
      this.showSuccessMessage('New Location has been deleted');
      this.unselectRow();
      this.venues = data.payload;
    });
  }

  updateMap() {
    this.selectedRow.lat = +this.selectedRow.lat;
    this.selectedRow.lng = +this.selectedRow.lng;
  }

  saveVenue() {
    // const requiredFields = [
    //   {id: 'time_zone', value: this.selectedRow.timeZone, fieldName: 'Time Zone'},
    //   {id: 'loc_code', value: this.selectedRow.venueCode, fieldName: 'Loc Code'},
    //   {id: 'name', value: this.selectedRow.name, fieldName: 'Name'},
    //   {id: 'address', value: this.selectedRow.address1, fieldName: 'Address'},
    //   {id: 'country', value: this.selectedRow.country, fieldName: 'Country'},
    // ];
    // if (this.hasEmptyFields(requiredFields)) {
    //   return;
    // }
    // const conditions = [
    //   {
    //     condition: (this.timeZones.indexOf(this.selectedRow.timeZone) < 0),
    //     id: 'time_zone', message: 'Time Zone must be selected from list'
    //   }
    // ];
    // if (this.hasErrorConditions(conditions)) {
    //   return;
    // }

    this.http_updateVenue(this.selectedRow, (data: any) => {
      this.showSuccessMessage('New Location has been updated');
      this.unselectRow();
      this.venues = data.payload;
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  filterTimeZone(event) {
    const query = event.query;
    this.filteredTimeZones = this.searchTimeZone(query, this.timeZones);
  }

  searchTimeZone(query, timeZones: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < timeZones.length; i++) {
      const timeZone = timeZones[i];
      if (timeZone.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(timeZone);
      }
    }
    return filtered;
  }

  unselectRow() {
    this.selectedRow = undefined;
    this.selectedLocation = [];
  }

  onVenueGroupSelect(e) {
    this.venueGroup = this.venueGroups.filter(el => {
      return el.id === e.node.id;
    })[0];
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/location-setup/location-setup.component.ts